import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "@core/services/auth/auth.service";
import { SESSION_CONSTANTS } from "@core/constants/auth-constants";
import { VERSION_INFO } from "@core/constants/version";
import {
  Breadcrumb,
  NavigationBreadcrumbsService,
  stripQueryAndFragment,
} from "@core/logging/navigation-breadcrumbs.service";

/**
 * Non-PII context attached to every reported error. Allowed fields only —
 * see docs/logging/02-error-tracking.md "Explicitly excluded from payloads"
 * before adding anything here.
 */
export interface ErrorContext {
  userRole: string | null;
  region: string | null;
  route: string;
  sessionAgeMs: number;
  appVersion: string;
  breadcrumbs: Breadcrumb[];
}

@Injectable({ providedIn: "root" })
export class ErrorContextBuilder {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly navigationBreadcrumbs = inject(NavigationBreadcrumbsService);

  build(): ErrorContext {
    return {
      userRole: this.authService.getRole()?.name ?? null,
      region: sessionStorage.getItem(SESSION_CONSTANTS.X_REGION),
      route: stripQueryAndFragment(this.router.url),
      sessionAgeMs: this.navigationBreadcrumbs.sessionAgeMs,
      appVersion: VERSION_INFO.appVersion,
      breadcrumbs: this.navigationBreadcrumbs.breadcrumbs,
    };
  }
}
